import { UPDATE_APP } from './types'

export const updateApp = data => {
  return {
    type: UPDATE_APP,
    payload: data
  }
}
